import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-navbar',
  template: `
      <!--<nav class="navbar navbar-expand-lg navbar-dark bg-app">
          <a class="navbar-brand" href="#">Navbar</a>
          <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
              <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarNav">
              <ul class="navbar-nav">
                  <li routerLink="home" routerLinkActive="active" class="nav-item">
                      <a class="nav-link">Home</a>
                  </li>
              </ul>
          </div>
      </nav>-->
    <div class="container">
        <div class="text-center">
            <img class="img-fluid m-b-30" src="assets/images/logo.png" width="450">
        </div>
    </div>
  `,
  styles: []
})
export class NavbarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
